import React from 'react';
import { FormattedMessage } from 'react-intl';

const NoListingsPanel = () => (
  <div className="mylisting-nospaces flex middle center">
    <FormattedMessage id="hosting.no_listings_panel.add_space_text" defaultMessage="Add a space to get started"/>
  </div>
);

export default NoListingsPanel;
